<div class="d-flex flex-row">
    <i class="fa {{ params?.menuIcon }}" style="cursor: pointer;" (click)="onHeaderIconClick($event)"></i>&nbsp;
    <div class="customHeaderLabel">{{ params?.displayName }}</div>
</div>
